import ApplicationError from '@/core/misc/ApplicationError';
import { ErrorSeverity } from '@/core/misc/ErrorSeverity';

/**
 * Критическая валидационная ошибка — нарушение бизнес-инварианта.
 *
 * Показывается пользователю как ошибка и репортится в Sentry.
 * Используется когда ситуация свидетельствует о рассинхроне данных
 * или невозможном состоянии системы.
 *
 * @example
 * throw new CriticalValidationError(
 *     'Получатель не является плательщиком НДС — невозможно добавить позицию с НДС',
 *     { receiverCompanyId: company.id, vatRateSeller: position.vatRateSeller }
 * );
 */
class CriticalValidationError extends ApplicationError {
    constructor(message: string, debugData: unknown = null) {
        super(message, -32511, ErrorSeverity.Error, debugData);
        this.name = 'CriticalValidationError';
    }
}

export default CriticalValidationError;